import Web3 from "web3";
import Eth from "web3-eth";
// import detectEthereumProvider from "@metamask/detect-provider";

const web3 = new Web3("https://polygon-mainnet.infura.io/v3/f28022963a954f69b2cb60dc8e79e428");

export const holdsToken = async (walletId, abi, address) => {
  let provider;
  if (!window.ethereum.providers) provider = window.ethereum;
  else provider = window.ethereum.providers.find((provider) => provider.isMetaMask);

  const eth = new Eth(provider);

  const contract = new eth.Contract(abi, address);

  const balance = await contract.methods.balanceOf(walletId).call();

  return parseInt(balance);
};

export const shortenPublicAddress = (address) => {
  if (!address) return null;
  return `${address.substring(0, 4)}...${address.substr(address.length - 5)}`;
};

export const connectToMetamask = async () => {
  let provider;
  if (!window.ethereum.providers) provider = window.ethereum;
  else provider = window.ethereum.providers.find((provider) => provider.isMetaMask);

  const isMetamaskUnlocked = await provider._metamask.isUnlocked();
  if (!isMetamaskUnlocked) return { isMetamaskUnlocked, chainId: null, walletId: null };

  const chainId = (await provider.request({ method: "eth_chainId" })) || null;
  const [walletId] = await provider.request({ method: "eth_requestAccounts" });

  return { chainId, walletId, isMetamaskUnlocked };
};

export const addTokenToMetamask = async (tokenAddress, tokenSymbol, tokenDecimals, tokenImage) => {
  // Check if the window.ethereum object is available
  if (typeof window.ethereum !== "undefined") {
    // Call the `request` method to add the token to Metamask
    await window.ethereum.request({
      method: "wallet_watchAsset",
      params: {
        type: "ERC20",
        options: {
          address: tokenAddress,
          symbol: tokenSymbol,
          decimals: tokenDecimals,
          image: tokenImage,
        },
      },
    });
  } else {
    // If the window.ethereum object is not available, display an error message
    console.error("Metamask not found");
  }
};

export const getOwnerOf = async (abi, address, tokenId) => {
  let provider;
  if (!window.ethereum.providers) provider = window.ethereum;
  else provider = window.ethereum.providers.find((provider) => provider.isMetaMask);

  const eth = new Eth(provider);

  const instance = new eth.Contract(abi, address);
  const result = await instance.methods.ownerOf(tokenId).call();

  return result;
};

export const getBalanceOf = async (walletAddress, contractAddress) => {
  const abi = [
    {
      inputs: [
        {
          internalType: "address",
          name: "_owner",
          type: "address",
        },
      ],
      name: "balanceOf",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
  ];

  // Create a new contract instance using the contract address and ABI
  const contract = new web3.eth.Contract(abi, contractAddress);

  // Call the balanceOf() function on the contract instance, passing in the wallet address as the argument
  const result = await contract.methods.balanceOf(walletAddress).call();

  const tokenBalance = web3.utils.fromWei(result, "ether");

  return tokenBalance;
};

export const getVestingOf = async (walletAddress, contractAddress, abi) => {
  const contract = new web3.eth.Contract(abi, contractAddress);

  const isVested = await contract.methods.isVested(walletAddress).call();

  let amountVested = 0;
  if (isVested) {
    amountVested = await contract.methods.vestedBalanceOf(walletAddress).call();
    amountVested = amountVested.toString().substring(0, 4);
  }

  return { isVested, amountVested };
};
